import { buildPanelItem } from "../helpers/buildPanelItem";
import { Label } from "../components/Label";

export const scoresLivenessPanel = [
  buildPanelItem(
    "1",
    Label({ label: "score", type: "string" }),
    "The liveness score. It ranges from 0 to 1.",
  ),
  buildPanelItem(
    "2",
    Label({ label: "threshold", type: "string" }),
    "The liveness threshold above which the liveness check passes.",
  ),
  buildPanelItem(
    "3",
    Label({ label: "status", type: "string" }),
    'Liveness status can be "live_person", "failed", or "not_available". The statuses "live_person" and "failed" derive directly from the liveness score and threshold. The status "not_available" means that liveness was not even evaluated because the capture device could not be deemed "healthy" as per the parameter "capture.status" above.',
  ),
];
